import { render, staticRenderFns } from "./ChooseUserTypeComponent.vue?vue&type=template&id=42184d7a"
import script from "./ChooseUserTypeComponent.js?vue&type=script&lang=js&external"
export * from "./ChooseUserTypeComponent.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports